export const link = [
    {
        id: 1,
        name: "Կենսաբանություն, 8-րդ դասարան",
        info: "https://www.imdproc.am/p/kensabanvotyvon/8-dasaran",
        menuItemId: 5
    },
    {
        id: 2,
        name: "Կենդանի օրգանիզմների դասակարգումը",
        info: "https://www.imdproc.am/p/kensabanvotyvon/7-dasaran/kensabanutyuny-vorpes-gitutyun-36188/kendani-organizmneri-dasakargumy-36189",
        menuItemId: 5
    },
    {
        id: 3,
        name: "Բակտերիաների և կապտականաչ ջրիմուռների ենթաթագավորություններ",
        info: "https://www.imdproc.am/p/kensabanvotyvon/7-dasaran/kvotvorakvvoghneri-tagavvorutyun-36191/bakterianeri-kaptakanach-jrimurneri-entatagavvorutyunner-36192",
        menuItemId: 5
    },
    {
        id: 4,
        name: "Ստորակարգ և բարձրակարգ սնկերի ենթաթագավորություններ",
        info: "https://www.imdproc.am/p/kensabanvotyvon/7-dasaran/snkeri-tagavvorutyun-36194/stvorakarg-bardzrakarg-snkeri-entatagavvorutyunner-36195",
        menuItemId: 5
    },
    {
        id: 5,
        name: "Բույսերի ընդհանուր բնութագիրը և դասակարգումը",
        info: "https://www.imdproc.am/p/kensabanvotyvon/7-dasaran/buyseri-tagavvorutyun-36197/buyseri-yndhanur-bnutagiry-dasakargumy-36198",
        menuItemId: 5
    },
    {
        id: 6,
        name: "Բույսերի բազմազանությունը, դերը բնության մեջ և մարդու կյանքում",
        info: "https://www.imdproc.am/p/kensabanvotyvon/7-dasaran/buyseri-taratsvatsutyuny-pahpanutyuny-37173/buyseri-bazmazanutyuny-dery-bnutyan-mej-mardu-kyanqum-37174",
        menuItemId: 5
    },
    {
        id: 7,
        name: "Կենդանիների ընդհանուր բնութագիրը և դասակարգումը",
        info: "https://www.imdproc.am/p/kensabanvotyvon/7-dasaran/kendanineri-tagavvorutyun-37929/kendanineri-yndhanur-bnutagiry-dasakargumy-37930",
        menuItemId: 5
    },
    {
        id: 8,
        name: "Բազմաբջիջ կենդանիների էական առանձնահատկությունները",
        info: "https://www.imdproc.am/p/kensabanvotyvon/7-dasaran/bazmabjij-kendanineri-entatagavvorutyun-39843/bazmabjij-kendanineri-eakan-arandznahatkutyunnery-39846",
        menuItemId: 5
    },
    {
        id: 9,
        name: "Աղեխորշավորների տիպ",
        info: "https://www.imdproc.am/p/kensabanvotyvon/7-dasaran/bazmabjij-kendanineri-entatagavvorutyun-39843/aghekhvorshavvorneri-tip-39848",
        menuItemId: 5
    },
    {
        id: 10,
        name: "Կենսաբանություն 7-րդ դասարան",
        info: "https://www.imdproc.am/p/kensabanvotyvon",
        menuItemId: 5
    },
    {
        id: 11,
        name: "Կենսաբանություն 8-րդ դասարան",
        info: "https://www.imdproc.am/p/kensabanvotyvon#program-8-dasaran",
        menuItemId: 5
    },
    {
        id: 12,
        name: "9-12-րդ դասարանների կենսաբանության ծրագրերի հաստատում",
        info: "https://www.arlis.am/hy/acts/55059",
        menuItemId: 5
    },
]
